// API base URLs - Backend routes are mounted under /api/v1/
// See: totalview-core/packages/api/src/totalview_api/main.py

// Base URL without version (for rare cases)
export const API_BASE =
  process.env.REACT_APP_API_URL ?? "https://api.totalview.energy";

// Versioned API URL - use this for all API calls
export const API = `${API_BASE}/api/v1`;

// Legacy alias (deprecated - use API instead)
export const API_V1 = API;